import ErrorDialogStore from './schema/ErrorDialogStore';
import { createStore } from 'satcheljs';
import './orchestrators/accountIsInErrorStateOrchestrator';
import './orchestrators/retryAccountUpdateTokenOrchestrator';
import { OWAConnectedAccountState } from 'owa-accounts-store';

let errorDialogStoreData: ErrorDialogStore = {
    isDialogHidden: true,
    failureState: OWAConnectedAccountState.Valid,
    hasUserRetried: false,
};

export default createStore<ErrorDialogStore>('owaAccountsErrorDialogStore', errorDialogStoreData);
